import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@iscr/lib/utils";
export const FormSectionHeader = ({ children, as: Tag = "h4", }) => {
    return (_jsx(Tag, { className: cn({
            "!text-icosm-tertiary border-icosm-tertiary pb-4 pt-4 -ml-2 mt-4 border-b-2 p-2 font-semibold uppercase tracking-widest !text-lg": app.settings.icosm,
        }), children: children }));
};
